/* Enhance the existing simulator without replacing its geometry or calculations. */
(() => {
  const lab = document.querySelector('[data-fitment-lab]');
  if (!lab || lab.dataset.motionReady) return;
  lab.dataset.motionReady = 'true';
  // Reserve space for the longest status at the current width and font size.
  const status = lab.querySelector('[data-fitment-status]');
  if (status) {
    let measuredWidth = -1;
    const sizeStatus = () => {
      const width = status.getBoundingClientRect().width;
      if (!width) return;
      measuredWidth = width;
      const probe = status.cloneNode(false);
      probe.removeAttribute('id');
      probe.removeAttribute('data-fitment-status');
      probe.removeAttribute('aria-live');
      probe.setAttribute('aria-hidden', 'true');
      probe.style.cssText = `position:absolute;visibility:hidden;pointer-events:none;width:${width}px;height:auto!important;min-height:0!important;box-sizing:border-box;`;
      status.parentElement.append(probe);
      let height = 0;
      for (const text of [
        'Possible Fender Contact',
        'MAKSTTON Balanced Flush Target — Wheel approximately 6 mm inside the fender.',
        'MAKSTTON Balanced Flush Target — Tire approximately 6 mm inside the fender.',
        'Near Flush — Wheel outer edge approximately aligns with the fender.',
        'Wheel approximately 40 mm inside the fender.'
      ]) {
        probe.textContent = text;
        height = Math.max(height, probe.getBoundingClientRect().height);
      }
      probe.remove();
      status.style.height = `${Math.ceil(height)}px`;
    };
    sizeStatus();
    new ResizeObserver(() => {
      if (Math.abs(status.getBoundingClientRect().width - measuredWidth) > 0.5) sizeStatus();
    }).observe(status);
    if (document.fonts) document.fonts.ready.then(sizeStatus);
  }

  const position = lab.querySelector('[data-position-range]');
  const overhang = lab.querySelector('[data-overhang-range]');
  const stage = lab.querySelector('.mw-fitment-stage');
  const svg = stage?.querySelector('svg');
  const wheel = lab.querySelector('[data-wheel-translate]');
  if (!position || !overhang || !svg || !wheel) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let frame = 0;
  const stop = () => { cancelAnimationFrame(frame); frame = 0; };
  const setPosition = value => {
    position.value = String(Math.max(Number(position.min), Math.min(Number(position.max), Math.round(value))));
    position.dispatchEvent(new Event('input', { bubbles: true }));
  };
  const presets = document.createElement('div');
  presets.className = 'mw-fitment-presets';
  presets.setAttribute('role', 'group');
  presets.setAttribute('aria-label', 'Compare wheel positions');
  const buttons = [];
  [[5, 'Inset 5 mm'], [0, 'Flush'], [-5, 'Beyond 5 mm']].forEach(([clearance, text]) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.textContent = text;
    button.addEventListener('click', () => {
      stop();
      const from = Number(position.value);
      const to = Math.max(Number(position.min), Math.min(Number(position.max), Math.max(0, Number(overhang.value)) + clearance));
      if (reduced.matches) { setPosition(to); return; }
      const start = performance.now();
      const tick = now => {
        const t = Math.min(1, (now - start) / 360);
        setPosition(from + (to - from) * (1 - Math.pow(1 - t, 3)));
        if (t < 1) frame = requestAnimationFrame(tick);
        else frame = 0;
      };
      frame = requestAnimationFrame(tick);
    });
    presets.append(button);
    buttons.push({button, clearance});
  });
  lab.querySelector('.mw-fitment-lab-controls').prepend(presets);
  const sync = () => {
    const clearance = Number(position.value) - Math.max(0, Number(overhang.value));
    buttons.forEach(({button, clearance: value}) => button.setAttribute('aria-pressed', String(clearance === value)));
  };
  position.addEventListener('input', sync);
  overhang.addEventListener('input', () => { stop(); sync(); });
  position.addEventListener('pointerdown', stop);
  position.addEventListener('keydown', stop);
  const hint = document.createElement('p');
  hint.className = 'mw-fitment-drag-hint';
  hint.textContent = 'Drag the wheel left or right, or use the controls above.';
  stage.after(hint);
  let drag = null;
  const svgX = e => {
    const matrix = svg.getScreenCTM();
    return matrix ? new DOMPoint(e.clientX, e.clientY).matrixTransform(matrix.inverse()).x : null;
  };
  wheel.addEventListener('pointerdown', e => {
    if (e.button !== 0) return;
    const x = svgX(e);
    if (x === null) return;
    stop();
    drag = { id: e.pointerId, x, value: Number(position.value) };
    wheel.setPointerCapture(e.pointerId);
    lab.classList.add('is-dragging');
    e.preventDefault();
  });
  wheel.addEventListener('pointermove', e => {
    if (!drag || e.pointerId !== drag.id) return;
    const x = svgX(e);
    if (x !== null) setPosition(drag.value + (x - drag.x) / 2.5);
  });
  const end = () => { drag = null; lab.classList.remove('is-dragging'); };
  wheel.addEventListener('pointerup', end);
  wheel.addEventListener('pointercancel', end);
  wheel.addEventListener('lostpointercapture', end);
  sync();
})();
